import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext } from 'react';
import { createPolymorphicComponent } from '../../helpers/react/polymorphicComponentTypes';
import { useStyles } from '../../hooks/useStyles';
import { CardContext } from '../Card';
import { Stack } from '../Stack';
import { cardContentStyles } from './CardContent.styles';
import { cardContentTheme } from './CardContent.stylex';
export const CardContent = createPolymorphicComponent(forwardRef(function CardContent(props, forwardedRef) {
    const { styles, sx, children, ...other } = props;
    const { combineStyles, globalStyles } = useStyles({
        name: 'CardContent',
        styles: [cardContentStyles, styles],
    });
    const context = useContext(CardContext);
    const { actionable } = context ?? {};
    return (_jsx(Stack, { gap: 4, ...other, sx: [
            cardContentTheme,
            globalStyles,
            combineStyles('host', actionable && 'host$actionable'),
            sx,
        ], ref: forwardedRef, children: children }));
}));
